<script setup>
/* eslint-disable no-unused-vars */
import {computed, onMounted, ref} from "vue";
import http from "@/http";

const initialFilter = {
  type: [],
  valid: [],
  flightLevel: [],
  regionName: []
}

const filters = ref();
const weatherCharts = ref([]);
const selectedFilter = ref({...initialFilter})
const selectedWeatherCharts = ref([]);

const results = computed(() => {
  if (selectedFilter.value.type.length > 0 ||
      selectedFilter.value.flightLevel.length > 0 ||
      selectedFilter.value.regionName.length > 0 ||
      selectedFilter.value.valid.length > 0)
    return weatherCharts.value.filter((x) => {
      const {type, valid, flightLevel, regionName} = selectedFilter.value;

      const matchesType = type.length === 0 || type.includes(x.type);
      const matchesValid = valid.length === 0 || valid.includes(x.valid);
      const matchesFlightLevel = flightLevel.length === 0 || flightLevel.includes(x.flightLevel);
      const matchesRegionName = regionName.length === 0 || regionName.includes(x.regionName);
      return matchesType && matchesValid && matchesFlightLevel && matchesRegionName;
    });
  return [];
})

async function getFilters() {
  await http.instance.get("/WXBriefingGenerator/weather-chart-filters").then((r) => {
    filters.value = r.data;
  })
}

async function getWeatherCharts() {
  await http.instance.get("/WXBriefingGenerator").then((r) => {
    weatherCharts.value = r.data;
  })
}

function moveUp(index) {
  if (index > 0) {
    const arr = selectedWeatherCharts.value;
    const item = arr.splice(index, 1)[0];
    arr.splice(index - 1, 0, item);
  }
}

function moveDown(index) {
  if (index < selectedWeatherCharts.value.length - 1) {
    const arr = selectedWeatherCharts.value;
    const item = arr.splice(index, 1)[0];
    arr.splice(index + 1, 0, item);
  }
}
const isGenerating = ref(false);
async function generatePdf() {
  isGenerating.value = true;

  const ids = selectedWeatherCharts.value.map(chart => chart.id);

  try {
    const response = await http.instance.post("/WXBriefingGenerator/create-pdf", ids, {
      responseType: "blob"
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "weather-charts.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("PDF oluşturulurken hata:", error);
    alert("PDF oluşturulamadı.");
  } finally {
    isGenerating.value = false;
  }
}

function clearFilters() {
  selectedFilter.value = JSON.parse(JSON.stringify(initialFilter))
}

onMounted(async () => {
  await getFilters()
  await getWeatherCharts();
})
</script>

<template>
  <div v-if="filters">
    <h1 class="is-size-2 has-text-centered">WX Briefing Generator</h1>
    <div class="columns is-flex box" style="margin-top: 0.5rem">
      <div class="column is-4">
        <h2 style="font-weight: bold; margin-bottom: 0.5rem">FILTERS (<a @click="clearFilters">Clear Filters</a>)</h2>
        <div>
          <ul style="column-count: 3">
            <li v-for="item in filters.valids" :key="item">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedFilter.valid" :value="item"> {{ item }}
              </label>
            </li>
          </ul>
        </div>
        <hr>
        <div>
          <ul style="column-count: 2">
            <li v-for="item in filters.types" :key="item">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedFilter.type" :value="item"> {{ item }}
              </label>
            </li>
          </ul>
        </div>
        <hr>
        <div>
          <ul style="column-count: 2">
            <li v-for="item in filters.regionNames" :key="item">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedFilter.regionName" :value="item"> {{ item }}
              </label>
            </li>
          </ul>
        </div>
        <hr>
        <div>
          <ul style="column-count: 3">
            <li v-for="item in filters.flightLevels" :key="item">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedFilter.flightLevel" :value="item"> {{ item }}
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-4" style="border-left: 2px dashed lightgray;"
           :style="[{'visibility':results.length > 0 ?'visible' : 'hidden'}]">
        <h2 style="font-weight: bold; margin-bottom: 0.5rem">RESULT</h2>
        <ul style="overflow: scroll; max-height: 70vh">
          <li v-for="item in results" :key="item.id">
            <label>
              <input type="checkbox" v-model="selectedWeatherCharts" :value="item"> {{ item.regionName }}
              {{ item.type }} {{ item.flightLevel }} {{ item.valid }}
            </label>
          </li>
        </ul>
      </div>
      <div v-if="selectedWeatherCharts.length > 0" class="column is-4" style="border-left: 2px dashed lightgray">
        <h2 style="font-weight: bold; margin-bottom: 0.5rem">SELECTED WEATHER CHART</h2>
        <ol style="list-style-type: decimal; overflow-y: auto; max-height: 70vh; padding-left: 1.5rem; margin-left: 0;">
          <li v-for="(item,index) in selectedWeatherCharts" :key="item.id">
            <label class="checkbox">
              <input type="checkbox" v-model="selectedWeatherCharts" :value="item"> {{ item.regionName }}
              {{ item.type }} {{ item.flightLevel }} {{ item.valid }}
            </label>
            <font-awesome-icon
                role="button"
                v-if="index < selectedWeatherCharts.length - 1"
                :icon="['fas', 'caret-down']"
                style="margin-left: 0.5rem; font-size:1.25rem; color:red; cursor:pointer"
                @click="moveDown(index)"
            />
            <font-awesome-icon
                role="button"
                v-if="index > 0"
                :icon="['fas', 'caret-up']"
                style="margin-left: 0.5rem; font-size:1.25rem; color:green; cursor:pointer"
                @click="moveUp(index)"
            />
          </li>
        </ol>
      </div>
    </div>
    <div>
      <div class="columns is-flex box" style="margin-top: 0.5rem">

        <button
            class="button is-success is-medium is-fullwidth"
            :class="{ 'is-loading': isGenerating }"
            :disabled="isGenerating"
            @click="generatePdf"
        >
          {{ isGenerating ? 'Please wait...' : 'Generate' }}
        </button>
      </div>
    </div>
  </div>

</template>